import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives/object-id-schema';
import { PromotionModelSchema } from '../promotion/promotion-model-schema';

export const NewLineItemPromotionSchema = oz.object({
  promotionId: ObjectIdSchema.optional(),
  name: oz.string(),
  description: oz.string().optional(),
  promotionModel: PromotionModelSchema,
  deductedAmount: oz.number(),
}).openapi('NewLineItemPromotion');

export type NewLineItemPromotion = oz.infer<typeof NewLineItemPromotionSchema>;